export default "__VITE_ASSET__GiPw3WDP__"